// Dispatches between the mock (offline default) and the real http backend.
// Set `BUN_PUBLIC_API_GATEWAY_URL=http://api.osmix.localhost/api/v1` at bundle
// time to hit the gateway (the running stack does this). Components import `api`
// from `@/api` and never know which is active — both implement `Api` 1:1.
import { mock } from "./mock";
import { createHttp } from "./http";
import type { Api } from "./types";

const GATEWAY_URL = process.env.BUN_PUBLIC_API_GATEWAY_URL;

export const api: Api = GATEWAY_URL ? createHttp(GATEWAY_URL) : mock;
